import FormCommand from '../../components/controls/FormCommand/FormCommand';
import TextBox from '../../components/controls/TextBox/TextBox';
import classes from './location-form.module.css';

export interface LocationFormProps { }

function LocationForm(props: LocationFormProps) {

	return (
		<div className='row'>
			<div className="col-7">
				<h3>Register Location</h3>
				<TextBox id='locationName' text='Location Name' />
				<TextBox id='locationAddress' text='Location Address' />

				<FormCommand />
			</div>
			<div className="col-5"></div>
		</div>
	);
}

export default LocationForm;